import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const SurveyProjectButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}))
